import { createRouter, createWebHistory ,createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NotFound from '../views/404.vue'

// 检测百度浏览器，使用 hash 模式
const isBaidu = /baidu/i.test(navigator.userAgent)
const router = createRouter({
  history: isBaidu ? createWebHashHistory() : createWebHistory(),
  routes: [
    
    {
      path: '/free',
      name: 'free',
      component: () => import('../views/SaasView.vue'),
      meta: {
        title: '酒吧SaaS系统_KTV经营管理系统_业务管理平台-九点半930pm官网',
        keywords: '酒吧SaaS系统,酒吧SaaS管理软件,KTVSaaS系统,KTVSaaS管理软件,酒吧经营管理系统,酒吧业务管理平台',
        description: '九点半酒吧管理系统，帮您轻松经营。丰富的酒吧、KTV等专用SaaS管理软件，支持预定点单支付一体化，以及成本管理、销售业绩管理、会员管理、促销活动等经营所需管理系统。同时30天的免费试用，让您更好的了解九点半酒吧管理系统的同时，指定更符合您需求的客制化SaaS酒吧管理软件',
      }
    },
    {
      path: '/data',
      name: 'data',
      component: () => import('../views/SaasView.vue'),
      meta: {
        title: '酒吧SaaS系统_KTV经营管理系统_业务管理平台-九点半930pm官网',
        keywords: '酒吧SaaS系统,酒吧SaaS管理软件,KTVSaaS系统,KTVSaaS管理软件,酒吧经营管理系统,酒吧业务管理平台',
        description: '九点半酒吧管理系统，帮您轻松经营。丰富的酒吧、KTV等专用SaaS管理软件，支持预定点单支付一体化，以及成本管理、销售业绩管理、会员管理、促销活动等经营所需管理系统。同时30天的免费试用，让您更好的了解九点半酒吧管理系统的同时，指定更符合您需求的客制化SaaS酒吧管理软件',
      }
    },
    {
      path: '/shanghu',
      name: 'shanghu',
      component: () => import('../views/PartnersView.vue'),
      meta: {
        title: '九点半11年专业酒吧管理系统_火热招募SaaS软件代理-九点半930pm官网',
        keywords: '九点半SaaS软件代理,酒吧加盟,酒吧管理软件代理,酒吧代理,酒吧系统代理',
        description: '九点半专业酒吧管理系统，拥有预定点单，商品管理，会员管理，店铺促销，财务管理，人员管理等丰富的产品功能。同时为九点半为软件代理人提供技术支持、服务支持。让SaaS代理商轻松拓客。',
      }
    },
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        title: '九点半酒吧管理系统_酒吧收银软件_免费酒馆管理软件_存酒点单系统-九点半930pm官网',
        keywords: '九点半,酒吧管理软件,酒吧管理系统,酒吧预定点单,酒吧私域营销',
        description: '免费使用！0元体验！24小时×7无缝支持！九点半酒吧夜店管理系统软件致力于提供专业夜生活消费场景专属的智能解决方案，顾客大数据和智慧营销平台。汇集酒吧装修设计，酒吧夜店营销策划方案，中国酒吧夜店排行榜等夜生活场景信息于一身',
      }
    },
    {
      path: '/proDesc',
      name: 'saas',
      component: () => import('../views/SaasView.vue'),
      meta: {
        title: '酒吧SaaS系统_KTV经营管理系统_业务管理平台-九点半930pm官网',
        keywords: '酒吧SaaS系统,酒吧SaaS管理软件,KTVSaaS系统,KTVSaaS管理软件,酒吧经营管理系统,酒吧业务管理平台',
        description: '九点半酒吧管理系统，帮您轻松经营。丰富的酒吧、KTV等专用SaaS管理软件，支持预定点单支付一体化，以及成本管理、销售业绩管理、会员管理、促销活动等经营所需管理系统。同时30天的免费试用，让您更好的了解九点半酒吧管理系统的同时，指定更符合您需求的客制化SaaS酒吧管理软件',
      }
    },
    {
      path: '/hardware',
      name: 'hardware',
      component: () => import('../views/HardwareView.vue')
    },
    {
      path: '/commercial',
      name: 'commercial-hardware',
      component: () => import('../views/CommercialHardwareView.vue')
    },
    {
      path: '/smart',
      name: 'smart-hardware',
      component: () => import('../views/SmartHardwareView.vue'),
      meta: {
        title: '酒吧智能经营设备_AI调酒机器人_智能台式|移动终端-九点半930pm官网',
        keywords: '酒吧智能经营设备,酒吧智能台式终端,酒吧智能移动终端,AI调酒机器人,酒吧AI智能机器人',
        description: '依托九点半酒吧管理软件，创新使用AI智能技术。提供机器人调酒、自助无人打酒、NFC支付、无纸化手持POS、扫码枪等，酒吧、KTV、餐酒吧所需要的智能商用硬件设备。为门店经营自动化提供一站式解决方案。',
      }
    },
    {
      path: '/features',
      name: 'features',
      component: () => import('../views/FeaturesView.vue')
    },
    {
      path: '/scenarios',
      name: 'scenarios',
      component: () => import('../views/ScenariosView.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
      meta: {
        title: '九点半-顾客大数据和智慧营销平台-九点半930pm官网',
        keywords: '关于九点半',
        description: '九点半(Nine Thirty)，顾客大数据和智慧营销平台。通过场景应用沉淀顾客数据，利用顾客大数据实现精准营销。使老客回流，新客引流。门店营销精准化、智能化，为顾客提供全新夜生活体验，为夜店开启智慧运营管理的全新纪元。',
      }
    },
    {
      path: '/toAgentRegister',
      name: 'partners',
      component: () => import('../views/PartnersView.vue'),
      meta: {
        title: '九点半11年专业酒吧管理系统_火热招募SaaS软件代理-九点半930pm官网',
        keywords: '九点半SaaS软件代理,酒吧加盟,酒吧管理软件代理,酒吧代理,酒吧系统代理',
        description: '九点半专业酒吧管理系统，拥有预定点单，商品管理，会员管理，店铺促销，财务管理，人员管理等丰富的产品功能。同时为九点半为软件代理人提供技术支持、服务支持。让SaaS代理商轻松拓客。',
      }
    },
    //联系我们
    {
      path: '/toRegister',
      name: 'contact',
      component: () => import('../views/ContactView.vue'),
      meta: {
        title: '诚邀SaaS软件代理商_九点半专业酒吧管理系统-九点半930pm官网',
        keywords: '酒吧加盟,SaaS软件代理,九点半软件代理,九点半系统代理',
        description: '九点半专业酒吧管理系统，诚邀全国SaaS软件代理加盟。11年专注酒吧管理系统。丰富的SaaS应用可支持多国语言，提供服务支持与技术支持。全国统一客服热线：400-0068-930；邮箱：bd@intellfusion.com；办公时间：周一至周日10：00-24：00。北京公司地址：北京市东城区金宝街2号快易名商；新加坡公司地址：78 SHENTON WAY#24-01A SINGAPORE（079120）',
      }
    },{
      path: '/contact2',
      name: 'contact2',
      component: () => import('../views/ContactView2.vue'),
      meta: {
        title: '诚邀SaaS软件代理商_九点半专业酒吧管理系统-九点半930pm官网',
        keywords: '酒吧加盟,SaaS软件代理,九点半软件代理,九点半系统代理',
        description: '九点半专业酒吧管理系统，诚邀全国SaaS软件代理加盟。11年专注酒吧管理系统。丰富的SaaS应用可支持多国语言，提供服务支持与技术支持。全国统一客服热线：400-0068-930；邮箱：bd@intellfusion.com；办公时间：周一至周日10：00-24：00。北京公司地址：北京市东城区金宝街2号快易名商；新加坡公司地址：78 SHENTON WAY#24-01A SINGAPORE（079120）',
      }
    },{//消息列表
      path: '/list',
      name: 'newsList',
      component: () => import('../views/newsListView.vue'),
      meta: {
        title: '酒吧管理软件动态_酒吧系统软件资讯-九点半930pm官网',
        keywords: '酒吧管理软件,酒吧系统软件',
        description: '免费使用！0元体验！24小时×7无缝支持！九点半酒吧夜店管理系统软件致力于提供专业夜生活消费场景专属的智能解决方案，顾客大数据和智慧营销平台。汇集酒吧装修设计，酒吧夜店营销策划方案，中国酒吧夜店排行榜等夜生活场景信息于一身',
      }
    },
    {//消息详情
      path: '/content/id/:id',
      name: 'newsDetail',
      component: () => import('../views/newsDetail.vue'),
      meta: {
        title: '诚邀SaaS软件代理商_九点半专业酒吧管理系统-九点半930pm官网' // 可以设置一个默认标题
      }
    },
    {//创业版
      path: '/saasEntrepreneurial',
      name: 'saasEntrepreneurial',
      component: () => import('../views/saasEntrepreneurial.vue'),
      meta: {
        title: '诚邀SaaS软件代理商_九点半专业酒吧管理系统-九点半930pm官网-九点半SaaS功能',
        keywords: '酒吧加盟,SaaS软件代理,九点半软件代理,九点半系统代理',
        description: '九点半专业酒吧管理系统，诚邀全国SaaS软件代理加盟。11年专注酒吧管理系统。丰富的SaaS应用可支持多国语言，提供服务支持与技术支持。全国统一客服热线：400-0068-930；邮箱：bd@intellfusion.com；办公时间：周一至周日10：00-24：00。北京公司地址：北京市东城区金宝街2号快易名商；新加坡公司地址：78 SHENTON WAY#24-01A SINGAPORE（079120）',
      }
    },
    {//专业自选版
      path: '/saasProfessional',
      name: 'saasProfessional',
      component: () => import('../views/saasProfessional.vue'),
      meta: {
        title: '诚邀SaaS软件代理商_九点半专业酒吧管理系统-九点半930pm官网-九点半SaaS功能',
        keywords: '酒吧加盟,SaaS软件代理,九点半软件代理,九点半系统代理',
        description: '九点半专业酒吧管理系统，诚邀全国SaaS软件代理加盟。11年专注酒吧管理系统。丰富的SaaS应用可支持多国语言，提供服务支持与技术支持。全国统一客服热线：400-0068-930；邮箱：bd@intellfusion.com；办公时间：周一至周日10：00-24：00。北京公司地址：北京市东城区金宝街2号快易名商；新加坡公司地址：78 SHENTON WAY#24-01A SINGAPORE（079120）',
      }
    },
    {//旗舰版
      path: '/saasUltimate',
      name: 'saasUltimate',
      component: () => import('../views/saasUltimate.vue'),
      meta: {
        title: '诚邀SaaS软件代理商_九点半专业酒吧管理系统-九点半930pm官网-九点半SaaS功能',
        keywords: '酒吧加盟,SaaS软件代理,九点半软件代理,九点半系统代理',
        description: '九点半专业酒吧管理系统，诚邀全国SaaS软件代理加盟。11年专注酒吧管理系统。丰富的SaaS应用可支持多国语言，提供服务支持与技术支持。全国统一客服热线：400-0068-930；邮箱：bd@intellfusion.com；办公时间：周一至周日10：00-24：00。北京公司地址：北京市东城区金宝街2号快易名商；新加坡公司地址：78 SHENTON WAY#24-01A SINGAPORE（079120）',
      }
    }, 
  ]
})
// 使用导航守卫动态设置标题
router.afterEach((to, from) => {
  // 假设你在组件中通过 Vuex 或其他方式获取了文章标题
  const articleTitle = to.params.articleTitle || to.meta.title;
  document.title = articleTitle;
});
router.onError((error) => {
  if (error.message.includes("Avoided redundant navigation")) {
    // 忽略重复导航错误
    return;
  }
  // 其他错误处理
});
// 监听 Vue 路由变化，手动上报 PV
router.afterEach((to) => {
  // 确保 _hmt 已加载（防止首次加载未初始化）
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath]) // 上报 PV
  }
})
// 添加全局 beforeEach 导航守卫
router.beforeEach((to, from, next) => {
  // 滚动到页面顶部
  window.scrollTo(0, 0);
  const { title, keywords, description } = to.meta;
  if (title) {
    document.title = title;
  }
  if (keywords) {
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    } else {
      const newMetaKeywords = document.createElement('meta');
      newMetaKeywords.name = 'keywords';
      newMetaKeywords.content = keywords;
      document.head.appendChild(newMetaKeywords);
    }
  }
  if (description) {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const newMetaDescription = document.createElement('meta');
      newMetaDescription.name = 'description';
      newMetaDescription.content = description;
      document.head.appendChild(newMetaDescription);
    }
  }
  next();
});
export default router